[
    {
        "id": "c28404ee-83fb-4b98-a3f5-7e520503f5f5",
        "name": "Default cadence",
        "kind": "gem",
        "is_default": true,
        "timing": [
            { "kind": "connect", "offset_days": 0 },
            { "kind": "email", "offset_days": 7 },
            { "kind": "linkedin", "offset_days": 7 },
            { "kind": "linkedin", "offset_days": 14 },
            { "kind": "email", "offset_days": 14 }
        ],
        "instructions": "You write concise, warm outreach for Patient Watch, a clinician-facing outcomes platform.\n\nTone: British English, Dale Carnegie-inspired - genuine interest in their practice, never pushy.\n\nFor each touch after connect:\n- Reference the clinician's name, company, and team when known.\n- Lead with value for their patients and clinic workflow, not product features.\n- Keep LinkedIn messages under 80 words; emails under 120 words.\n- End with a soft ask (quick look / 15-minute chat), then \"Best,\\nGuy\".\n\nDo not invent clinical claims. Do not use emojis.",
        "artifact_ids": ["6f1d2c3a-8b14-4e09-9c2e-1a7b0d4e5f60"]
    },
    {
        "id": "37be146c-8e01-4263-b8d4-c00578f17ef5",
        "name": "Light follow-up",
        "kind": "customgpt",
        "is_default": false,
        "timing": [
            { "kind": "connect", "offset_days": 0 },
            { "kind": "email", "offset_days": 10 }
        ],
        "instructions": "You write a single short follow-up email after a LinkedIn connect for Patient Watch.\n\nTone: British English, friendly and brief.\n\nAssume they accepted the connection. Thank them, mention one relevant outcomes pain point for their specialty or team, and offer a short walkthrough.\n\nKeep the email under 90 words. Sign off \"Best,\\nGuy\". No emojis.",
        "artifact_ids": ["6f1d2c3a-8b14-4e09-9c2e-1a7b0d4e5f60"]
    },
    {
        "id": "92ae1aba-8796-4d79-b486-0905f4e0e02e",
        "name": "MSK sprint",
        "kind": "gem",
        "is_default": false,
        "timing": [
            { "kind": "connect", "offset_days": 0 },
            { "kind": "linkedin", "offset_days": 3 },
            { "kind": "email", "offset_days": 7 }
        ],
        "instructions": "You write MSK-focused outreach for Patient Watch.\n\nTone: British English, peer-to-peer with orthopaedic and sports clinicians.\n\nEmphasise PROMs without extra clinic burden, injection and surgery pathways, and clearer follow-up between visits.\n\nLinkedIn message: under 70 words. Email: under 110 words. Soft ask for a demo. Sign off \"Best,\\nGuy\". No emojis.",
        "artifact_ids": ["6f1d2c3a-8b14-4e09-9c2e-1a7b0d4e5f60", "d0a6c3e4-5f71-4c92-b3a4-8e0f2b3c4d55"]
    }
]
